// Projecten (echt uitgevoerd werk) en inspiratiebeelden: labels, filters en koppelingen.
import { CITIES } from "./cities";
import { imageUrl } from "../lib/api";

export const PROJECT_CATEGORIES = [
  { id: "kunststof_kozijnen", label: "Kunststof kozijnen", href: "/kunststof-kozijnen", onderwerp: "kunststof-kozijnen" },
  { id: "aluminium_kozijnen", label: "Aluminium kozijnen", href: "/aluminium-kozijnen", onderwerp: "aluminium-kozijnen" },
  { id: "schuifpui", label: "Schuifpuien", href: "/schuifpuien", onderwerp: "kunststof-schuifpui" },
  { id: "voordeur", label: "Deuren", href: "/deuren", onderwerp: "kunststof-deuren" },
  { id: "complete_vervanging", label: "Complete kozijnvervanging", href: "/kunststof-kozijnen", onderwerp: "meerdere-kozijnen" },
];
export const categoryLabel = (id) => PROJECT_CATEGORIES.find((c) => c.id === id)?.label || id;

export const PROJECT_STATUSES = [
  { id: "draft", label: "Concept", tone: "bg-slate-100 text-slate-700 ring-slate-200" },
  { id: "review", label: "Gereed voor controle", tone: "bg-amber-50 text-amber-800 ring-amber-200" },
  { id: "published", label: "Gepubliceerd", tone: "bg-emerald-50 text-emerald-700 ring-emerald-200" },
  { id: "archived", label: "Gearchiveerd", tone: "bg-slate-200 text-slate-600 ring-slate-300" },
];
export const statusOf = (id) => PROJECT_STATUSES.find((s) => s.id === id) || PROJECT_STATUSES[0];

export const PHOTO_PHASES = [
  { id: "voor", label: "Situatie vóór montage" },
  { id: "demontage", label: "Demontage" },
  { id: "montage", label: "Montage nieuwe kozijnen" },
  { id: "detail", label: "Technische details" },
  { id: "resultaat", label: "Eindresultaat" },
  { id: "afwerking", label: "Binnen- en buitenafwerking" },
];

export const MATERIAL_OPTIONS = ["Kunststof", "Aluminium", "Kunststof en aluminium"];
export const GLASS_OPTIONS = ["HR++", "HR+++ (triple)", "HR++ en HR+++"];

const MATERIAL_ONDERWERP = { schuifpui: { Aluminium: "aluminium-schuifpui" }, voordeur: { Aluminium: "aluminium-deuren" } };
// Onderwerp voor de offertewizard op basis van de eerste categorie en het materiaal van een project.
export const projectOnderwerp = (p) => {
  const cat = p.categories?.[0];
  const base = PROJECT_CATEGORIES.find((c) => c.id === cat);
  return MATERIAL_ONDERWERP[cat]?.[p.specs?.materiaal] || base?.onderwerp || "";
};
export const cityName = (slug) => CITIES.find((c) => c.slug === slug)?.name || "";

// ---------- Inspiratie ----------
export const INSPIRATION_FILTERS = [
  { key: "type", label: "Producttype", options: [["kozijnen", "Kozijnen"], ["schuifpuien", "Schuifpuien"], ["deuren", "Deuren"]] },
  { key: "material", label: "Materiaal", options: [["kunststof", "Kunststof"], ["aluminium", "Aluminium"]] },
  { key: "color", label: "Kleur", options: [["wit", "Wit"], ["cremewit", "Crèmewit"], ["antraciet", "Antraciet"], ["zwart", "Zwart"], ["houtlook", "Houtlook"], ["overig", "Overig"]] },
  { key: "style", label: "Woningstijl", options: [["modern", "Modern"], ["klassiek", "Klassiek"], ["jaren30", "Jaren 30"], ["landelijk", "Landelijk"]] },
  { key: "uitvoering", label: "Uitvoering", options: [["draaikiep", "Draai-kiepramen"], ["vast_glas", "Grote glasvlakken"], ["roedes", "Met roedes"],
    ["schuif", "Schuifpui"], ["hefschuif", "Hefschuifpui"], ["openslaand", "Openslaande deuren"], ["zijlicht", "Met zij- of bovenlicht"], ["dicht_paneel", "Dicht paneel"]] },
];
export const ONDERWERP_OPTIONS = [
  ["kunststof-kozijnen", "Kunststof kozijnen", "kozijnen"], ["aluminium-kozijnen", "Aluminium kozijnen", "kozijnen"],
  ["kunststof-schuifpui", "Kunststof schuifpui", "schuifpuien"], ["aluminium-schuifpui", "Aluminium schuifpui", "schuifpuien"],
  ["aluminium-hefschuifpui", "Aluminium hefschuifpui", "schuifpuien"], ["kunststof-deuren", "Kunststof deur", "deuren"],
  ["aluminium-deuren", "Aluminium deur", "deuren"],
];
export const onderwerpLabel = (id) => ONDERWERP_OPTIONS.find((o) => o[0] === id)?.[1] || id;
export const productType = (onderwerp) => ONDERWERP_OPTIONS.find((o) => o[0] === onderwerp)?.[2] || "";
export const optionLabel = (key, value) => INSPIRATION_FILTERS.find((f) => f.key === key)?.options.find((o) => o[0] === value)?.[1] || "";
export const BEELDTYPE_OPTIONS = [["foto", "Foto (stock of leverancier, met gebruiksrecht)"], ["illustratie", "Illustratie (gemaakt beeld, geen foto)"]];
export const beeldLabel = (it) => (it?.beeldtype === "illustratie" ? "Illustratie" : "Inspiratiebeeld");
export const INSPIRATION_STATUSES = [["published", "Zichtbaar"], ["concept", "Concept"], ["hidden", "Verborgen"]];

// Eigen beeldbank-afbeeldingen (…-1280.webp) en de mediabibliotheek (…/public/media/…webp) hebben ook een 720-variant voor mobiel.
export const imgSet = (path) => {
  const m = /^(\/images\/v3\/.+)-1280\.webp$/.exec(path || "");
  if (m) return `${m[1]}-720.webp 720w, ${path} 1280w`;
  const lib = /^([\w-]+\/public\/media\/[\w-]+)\.webp$/.exec(path || "");
  return lib ? `${imageUrl(`${lib[1]}-720.webp`)} 720w, ${imageUrl(path)} 1600w` : undefined;
};
